import { motion } from "framer-motion";
import { Printer, Layers, Scissors, PenTool } from "lucide-react";
import { BENEFITS } from "../data/site";

const ICONS = [PenTool, Printer, Scissors, Layers];

export const Benefits = () => (
  <section data-testid="benefits-strip" className="px-5 sm:px-10">
    <div className="grid grid-cols-2 lg:grid-cols-4 border-y border-ink/10">
      {BENEFITS.map((b, i) => {
        const Icon = ICONS[i];
        return (
          <motion.div
            key={b.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className={`flex items-center gap-3 sm:gap-4 py-5 sm:py-6 px-2 sm:px-4 ${i % 2 ? "" : "border-r border-ink/10"} ${i === 1 ? "lg:border-r" : ""}`}
          >
            <span className="grid place-items-center h-10 w-10 sm:h-11 sm:w-11 shrink-0 rounded-full bg-alga/10 text-alga"><Icon className="h-5 w-5" strokeWidth={2} /></span>
            <span className="leading-tight">
              <span className="block text-sm sm:text-base font-bold">{b.title}</span>
              <span className="block text-xs sm:text-sm text-ink-soft">{b.sub}</span>
            </span>
          </motion.div>
        );
      })}
    </div>
  </section>
);
